import services from '../../../services'

// const moduleName = 'person'
// const lastUpdateTimeKey = `__module_${moduleName}_last_update_time__`
// const timeGap = 1 * 1 * 1000

const state = {
  info: {}
}

const actions = {
  // fetchCookie (name) {
  //   let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  //   if (arr != null) return decodeURIComponent(arr[2]);
  //   return null;
  // },
  // deleteCookie (name) {
  //   let cval = this.fetchCookie(name);
  //   if (cval != null) document.cookie = name + "=" + cval + ";max-age=-1;";
  // },
  async isOwnPermission ({commit}, query) {
    return await services.person_isOwnPermission(query.id, query.params)
  },
  async faceCheck ({commit}, options) {
    return await services.person_faceCheck(options)
  },
  async personAll ({commit}, query) {
    return await services.person_personAll(query)
  },
  async personQuery ({commit}, query) {
    return await services.person_query(query)
    /* if (res.data.results) {
      res.data.results.forEach((element) => {
        element.status = element.status === 0 ? '离职' : '在职'
      }, this)
    } */
  },
  async getPeronName ({commit}, query) {
    // let lastUpdateTime = state.personInfo[lastUpdateTimeKey] || 0
    // if (Date.now() - lastUpdateTime < timeGap) {
    //   let name = state.personInfo.profile.name || ''
    //   return Promise.resolve(name)
    // }
    return await services.person_getName(query).then(res => {
      return res.profile.name
    })
  },
  async updatePerson ({commit}, options) {
    return await services.person_update(options.peopleId, options)
  },
  async addPerson ({commit}, options) {
    return await services.person_add(options)
  },
  async importPerson ({commit}, options) {
    return await services.person_importPerson(options)
  },
  async importPeople ({commit}, options) {
    return await services.person_importPeople(options)
  },
  async allowedImport({commit}, query) {
    return await services.person_allowedImport(query);
  },
  async pollImportResult({commit}, id) {
    return await services.person_pollImportResult(id);
  },
  async downloadFile ({commit}, query) {
    return await services.person_downloadFile(query)
  },
  async getPersonByQuery ({commit}, query) {
    return await services.person_getPersonByQuery(query)
  },
  async getPerson ({commit}, query, statusFlag = false) {
    // let lastUpdateTime = state.info[lastUpdateTimeKey] || 0
    // if (Date.now() - lastUpdateTime < timeGap) {
    //   return Promise.resolve(state.info)
    // }
    let result = await services.person_getPerson(query)
    if (!result) {
      result = Promise.reject({ message: "该用户没有权限" })
    }
    return result
  },
  async deletePerson ({commit}, query) {
    let params = {
      identityId: query.identityId,
      peopleId: query.peopleId
    }
    return await services.person_delete({params: params})
  },
  // 批量删除用户信息
  async deletePersonBatch ({commit}, query) {
    let params = {
      peopleInfos: query.peopleInfos
    }
    return await services.person_deleteBatch({params: params})
  },
  async exportPeople ({commit}, options) {
    return await services.person_exportPeople(options)
  }
}

const mutations = {
  personInfo(state, payload) {
    let personInfo = payload || {}
    // personInfo[lastUpdateTimeKey] = Date.now()
    state.info = personInfo
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/person.js